import Vue from "vue";

import {
  ValidationProvider,
  ValidationObserver,
  localize,
  extend
} from 'vee-validate';

import pt_BR from "vee-validate/dist/locale/pt_BR.json";

import * as rules from 'vee-validate/dist/rules';


Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

localize('pt_BR', pt_BR);

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);